import { Link } from "react-router-dom";
import { useOpportunityMeetings } from "@/hooks/use-meeting-summary";
import { formatDateTimeShort } from "@/lib/format";
import { MEETING_STATUS_LABELS } from "@/lib/meeting-labels";

/** Møtene på prosessen med lenke til møte og referat (lead-prosesser har ingen kundeside å åpne dem fra). */
export default function OpportunityMeetings({ opportunityId }: { opportunityId: string }) {
  const { data: meetings = [] } = useOpportunityMeetings(opportunityId);
  if (meetings.length === 0) return null;
  return (
    <section aria-label="Møter" className="mt-4 space-y-1">
      <h3 className="text-xs font-medium uppercase tracking-wide text-muted-foreground">Møter</h3>
      <ul className="divide-y divide-border border border-border text-sm">
        {meetings.map((m) => (
          <li key={m.id} className="flex flex-wrap items-center justify-between gap-2 p-2">
            <span className="min-w-0 truncate">
              {m.title} · {formatDateTimeShort(m.start_at)} · {MEETING_STATUS_LABELS[m.status]}
            </span>
            <Link to={m.customer_id ? `/kunde/${m.customer_id}/moter/${m.id}` : `/moter/${m.id}`} className="text-xs underline underline-offset-4">
              Åpne møte og referat
            </Link>
          </li>
        ))}
      </ul>
    </section>
  );
}
